"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadDictionaryTerms = loadDictionaryTerms;
exports.loadDictionaryTermsSuccess = loadDictionaryTermsSuccess;
var _dictionaryTermsApi = _interopRequireDefault(require("../api/dictionaryTermsApi"));
var _settings = require("../settings");
var _ajaxStatusActions = require("./ajaxStatusActions");
var _actionTypes = require("./actionTypes");
function loadDictionaryTermsSuccess(data) {
  return {
    type: _actionTypes.LOAD_DICTIONARY_TERMS_SUCCESS,
    data: data
  };
}
function loadDictionaryTerms() {
  return function (dispatch) {
    dispatch((0, _ajaxStatusActions.beginAjaxCall)());
    var _getSettings = (0, _settings.getSettings)(),
      loadDictionaryTermsApi = _getSettings.loadDictionaryTermsApi,
      productLineId = _getSettings.productLineId;
    return (0, _dictionaryTermsApi["default"])(loadDictionaryTermsApi, productLineId).then(function (data) {
      dispatch(loadDictionaryTermsSuccess(data.data));
    });
  };
}
//# sourceMappingURL=dictionaryActions.js.map